import React, { useState } from 'react';

import { endpoints } from "./endpoints.js";
import { copyToClipboard } from './util.js';
import { fetchWithJWT } from './requests.js';

function CreateKey() {
  const [newKey, setNewKey] = useState("");
  const [tierSelect, setTierSelect] = useState(1);

  const genereteNewKey = () => {
    let body = {"tier": tierSelect};
    fetchWithJWT(endpoints.postKeys, "POST", body, (data) => {
      setNewKey(data["Key"]);
    }, console.log);
  };

  const handleTierSelect = (event) => {
    let tier = event.target.value;
    setTierSelect(Number(tier));
  };

  const copy = () => {
    copyToClipboard(newKey);
  }

  return (
    <div className="container block">
      <h2 className="title has-text-weight is-4 honey-text-font-family honey-text-common">
        Create a Key
      </h2>
      <div className="level">
        <div className="level-left">
          <div className="level-item">
            <button className="button honey-button" onClick={genereteNewKey}>New Key</button>
          </div>
          <div className="level-item">
            <div className="select">
              <select onChange={handleTierSelect}>
                <option value="4">Basic</option>
                <option value="3">Pro</option>
                <option value="2">Enterprise</option>
                <option value="1">Admin</option>
              </select>
            </div>
          </div>
        </div>
        <div className="level-right">
          <div className="field has-addons">
            <div className="control">
              <input
                className="input honey-input-focus-color"
                type="text"
                placeholder="New Key"
                value={newKey}
                readOnly
              />
            </div>
            <div className="control">
              <button className="button honey-button" onClick={copy}>Copy</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateKey;
